module.exports = __webpack_public_path__ + "media/images/enabled_procedure_managements/area_examples-f5ed8e66b5df17ca44c853182bf8b604.png";